export default {
  menu: {
    sports: "Sports",
    referAndEarn: "Mag-refer at Kumita",
    referDesc: "hanggang 60% komisyon",
    copyLink: "Kopyahin ang Link",
    hot: "Mainit",
    favorites: "Mga Paborito",
    recent: "Kamakailang",
    vipClub: "VIP Club",
    bonus: "Bonus",
    bonusGames: "Mga Laro ng Bonus",
    affiliate: "Kaakibat",
    promotion: "Promosyon",
    rewards: "Mga Gantimpala",
    help: "Tulong",
    feedback: "Feedback",
    downloadApp: "I-download ang App",
    claimBonus: "Kunin ang Bonus",
    redeemCode: 'Tubusin ang Code',
    redeemDesc: 'Kunin ang Libreng Reward',
    liveSupport: "Live na Suporta",
    language: "Wika",
	search: "search"
  }
}
